import RedBlackTreeVisualizer from "./red-black-tree-visualizer"

export default function Rbt() {
  return (
    <main className="h-screen">
      <RedBlackTreeVisualizer />
    </main>
  )
}
